<div class="modal fade" id="Push_Modal" tabindex="-1" aria-labelledby="" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        <h5 class="modal-title ms-0">ارسال پیام به راننده</h5>
      </div>

      <div class="modal-body" [formGroup]="pushForm">
        <!-- انتخاب نوع پیام -->
        <ng-container *ngIf="pushType == 0">
          <p class="push-hint">نوع پیامی که می‌خواهید برای راننده ارسال شود را انتخاب کنید:</p>
          <div class="push-choice">
            <button type="button" class="push-choice-card" (click)="setType('2')">
              <span class="push-choice-icon voice"><i class="fa fa-microphone"></i></span>
              <span class="push-choice-text">
                <b>پیام صوتی</b>
                <small>ضبط صدا و ارسال (حداکثر ۲۰ ثانیه)</small>
              </span>
              <i class="fa fa-chevron-left push-choice-go"></i>
            </button>
            <button type="button" class="push-choice-card" (click)="setType('1')">
              <span class="push-choice-icon text"><i class="fa fa-envelope-o"></i></span>
              <span class="push-choice-text">
                <b>پیام متنی</b>
                <small>ارسال عنوان و متن به راننده</small>
              </span>
              <i class="fa fa-chevron-left push-choice-go"></i>
            </button>
          </div>
        </ng-container>

        <!-- پیام متنی -->
        <ng-container *ngIf="pushType == 1">
          <div class="push-field">
            <label>عنوان <span class="req">*</span></label>
            <input class="form-control" formControlName="strTitle" placeholder="مثلاً اطلاعیه سرویس دوره‌ای">
          </div>
          <div class="push-field">
            <label>متن پیام <span class="req">*</span></label>
            <textarea class="form-control" rows="4" formControlName="strMessage" placeholder="متن پیام خود را وارد کنید"></textarea>
          </div>
          <label class="push-option" *ngIf="canSendPayamak">
            <input class="form-check-input m-0" type="checkbox" formControlName="bSMS">
            <span>هم‌زمان پیامک هم ارسال شود</span>
          </label>
        </ng-container>

        <!-- پیام صوتی -->
        <ng-container *ngIf="pushType == 2">
          <div class="push-field">
            <label>عنوان <span class="req">*</span></label>
            <input class="form-control" formControlName="strTitle" placeholder="مثلاً پیام صوتی مدیر ناوگان">
          </div>
          <div class="recorder" [class.is-recording]="isAudioRecording" [class.is-done]="!isAudioRecording && isAudioRecorded()">
            <!-- آماده ضبط -->
            <ng-container *ngIf="!isAudioRecording && !isAudioRecorded()">
              <button type="button" class="rec-btn" (click)="startAudioRecording()" title="شروع ضبط">
                <i class="fa fa-microphone"></i>
              </button>
              <div class="rec-title">ضبط صدا <span class="req">*</span></div>
              <div class="rec-sub">برای شروع ضبط لمس کنید (حداکثر ۲۰ ثانیه)</div>
            </ng-container>
            <!-- در حال ضبط -->
            <ng-container *ngIf="isAudioRecording && !isAudioRecorded()">
              <button type="button" class="rec-btn recording" (click)="stopAudioRecording()" title="توقف ضبط">
                <i class="fa fa-square"></i>
              </button>
              <div class="rec-title">در حال ضبط…</div>
              <div class="rec-timer">{{ audioRecordedTime | faNum }}</div>
              <button type="button" class="btn btn-outline-danger btn-sm" (click)="stopAudioRecording()">توقف ضبط</button>
            </ng-container>
            <!-- ضبط شده -->
            <ng-container *ngIf="!isAudioRecording && isAudioRecorded()">
              <div class="rec-done-head">
                <span class="rec-ok"><i class="fa fa-check-circle"></i> صدا ضبط شد</span>
                <button type="button" class="btn btn-light btn-sm" (click)="clearRecordedAudio()" title="حذف و ضبط مجدد">
                  <i class="fa fa-trash"></i> حذف
                </button>
              </div>
              <audio *ngIf="audioSrcUrl" controls class="w-100 rounded">
                <source [src]="audioSrcUrl" type="audio/mp3">
                Your browser does not support the audio element.
              </audio>
            </ng-container>
          </div>
        </ng-container>
      </div>

      <div class="modal-footer push-footer">
        <ng-container *ngIf="pushType != 0">
          <button class="btn btn-light" (click)="back()">مرحله قبل</button>
          <button type="button" class="btn btn-success push-send" (click)="send()">
            <i class="fa fa-send"></i> ارسال پیام
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</div>
